function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Laptop(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.46 2c1.104 0 2 .897 2 2v8c0 .206-.031.404-.089.59a.898.898 0 01.061.174l1.431 5.883c.146.601.01 1.224-.372 1.71a1.984 1.984 0 01-1.57.763H3a1.985 1.985 0 01-1.572-.764 1.983 1.983 0 01-.37-1.708l1.43-5.884c.014-.06.034-.118.059-.173a2.04 2.04 0 01-.088-.59V4c0-1.104.897-2 2-2h15zM4.434 14h-.188l-1.245 5.12h17.921L19.675 14H4.434zm9.311 2.35a1 1 0 110 2h-3.569a1 1 0 110-2h3.57zM19.46 4h-15v8H19.46l-.001-8z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoLaptop = /*#__PURE__*/React.memo(Laptop);
export default MemoLaptop;